export default __webpack_public_path__ + "static/eight-b69c4dfa20011f47cbc9ec7c76340009.png";